import AnswerRenderer from './AnswerRenderer';
export default AnswerRenderer;